import { Task } from "../../../app/backendTypes";
import Loading from "../Loading";
import Error from "../Error";
import { useTask } from "../../../app/hooks";

function TaskLoader(props: {
  id: string;
  render: (task: Task, reload: () => void) => void;
  close?: () => void;
}) {
  const { id, render, close } = props;

  const { task, loading, error, reload } = useTask(id);

  if (loading) return <Loading close={close} />;
  if (error) return <Error error={error} close={close} />;
  if (task !== null) return <>{render(task, reload)}</>;

  return <></>;
}

export default TaskLoader;
